<template>
    <div @click.stop>
        <form action="." @submit.prevent="search()" v-bind="$attrs">
            <input class="flex:1 py:16 outline:none" @click="focus" :id="id" placeholder="輸入關鍵字" ref="input" type="search" v-model.trim="info.part.search" />
            <img alt="" class="inline w:20 ml:8 cursor:pointer" @click="search()" src="image/icon_header_search.svg" />
        </form>
        <div class="{abs;top:100%;pt:4;left:0;z:$(modal-zindex);w:full}" v-if="active && info.part.keywords.length">
            <div class="{w:full;box-shadow:0|4|20|0|#0000001A;p:20:16;r:20;bg:white}">
                <div class="flex jc:space-between ai:center pl:12">
                    <div class="{font:bold;lh:1.5}">相關結果</div>
                </div>
                <div class="
                    mt:12
                    {flex;ai:center;gap:8;p:14|16;bb:1|solid|#EBEBEB;cursor:pointer}_.history-item
                    {bg:#F8F8F8}_.history-item:hover
                    {mt:12}_.history-item+.history-item
                    {flex:1;lh:1.5}_.item-label
                ">
                    <div class="history-item" @click="search(item)" :key="item" v-for="(item) in info.part.keywords">
                        <div class="item-label">{{ item }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="{abs;top:100%;pt:4;left:0;z:$(modal-zindex);w:full}" v-else-if="active && info.part.searched?.length">
            <div class="{w:full;box-shadow:0|4|20|0|#0000001A;p:20:16;r:20;bg:white}">
                <div class="flex jc:space-between ai:center pl:12">
                    <div class="{font:bold;lh:1.5}">我搜尋過的</div>
                    <button class="p:8|12 f:14 color:#5E6472 font:bold" @click="info.removePartSearchLog(partId)">清除紀錄</button>
                </div>
                <div class="
                    mt:12
                    {flex;ai:center;gap:8;p:14|16;bb:1|solid|#EBEBEB;cursor:pointer}_.history-item
                    {bg:#F8F8F8}_.history-item:hover
                    {mt:12}_.history-item+.history-item
                    {flex:1;lh:1.5}_.item-label
                    {inline-flex;w:32;h:32;bg:url(image/part/icon_delete.svg);background-repeat:no-repeat;background-position:center|center}_.btn-remove
                ">
                    <div class="history-item" @click="search(item)" :key="item" v-for="(item) in info.part.searched.slice(-10).reverse()">
                        <div class="item-label">{{ item }}</div>
                        <button class="btn-remove" @click.stop="info.removePartSearchLog(partId, item)"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const { watchThrottled } = VueUse;

    const props = defineProps({
        partId: { type: Number },
        popup: { default: true, type: Boolean }
    });

    const entered = ref(false);
    const id = nextId();
    const info = useSearchInfo();
    const input = ref();

    const active = computed(() => props.popup && entered.value && info.part.active === id);

    const blur = () => {
        entered.value = false;

        emit("blur");
    }

    const emit = defineEmits(["blur", "focus"]);

    const focus = () => {
        entered.value = true;

        info.part.active = id;

        emit("focus");
    }

    const search = (keyword) => {
        info.searchPart(props.partId, keyword);
    }

    info.initPartSearchLogs(props.partId);

    onMounted(() => {
        document.body.addEventListener("click", blur);
    });

    watchThrottled(() => info.part.search, () => {
        if (info.part.search) {
            api("app/search/list-keyword", { part_id: props.partId, keyword: info.part.search }).done((res) => {
                if (res.success) {
                    info.part.keywords = res.data;
                }
            });
        } else {
            info.part.keywords = [];
        }
    }, { throttle: 500 });
</script>
